/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PurchaseStatus {
    PENDING = 'Pending',
    SUCCESS = 'Success',
    FAILED = 'Failed',
}
